const formatNumber = (number: string | number, currentLanguage: string = "pt", decPlaces: number = 2, charToReplaceWith: string  = ",", charToBeReplaced: string = "."):string => {
	let characterToBeReplacedWith = charToReplaceWith;
	let characterToBeReplaced = charToBeReplaced;
	let decimalPlaces = decPlaces;
	let numberAsStringToFormat = "0";
	
	if(number)
		numberAsStringToFormat = typeof number === "string" ? number : number.toString();

	numberAsStringToFormat = numberAsStringToFormat.replace(/[a-z]/g, "").replace(/[A-Z]/g, "");

	if(currentLanguage === "pt" || currentLanguage === "es"){
		characterToBeReplacedWith = ",";
		characterToBeReplaced = ".";
	}

	if(currentLanguage === "en"){
		characterToBeReplacedWith = ".";
		characterToBeReplaced = ",";
	}

	if (numberAsStringToFormat === "") return `0${characterToBeReplacedWith}00`;
	decimalPlaces = Number.isFinite(+decimalPlaces) ? Math.abs(decimalPlaces) : 0;
  
	if(!characterToBeReplacedWith){
    	characterToBeReplacedWith = 0.1.toLocaleString().charAt(1);
	}

	characterToBeReplaced = !characterToBeReplaced ?  "" : characterToBeReplaced;
  
	const n = `\\u${  `0000${  characterToBeReplacedWith.charCodeAt(0).toString(16)}`.slice(-4)}`;
	const r = `\\u${  `0000${  characterToBeReplaced.charCodeAt(0).toString(16)}`.slice(-4)}`;
	const o = new RegExp(n, "g");
	const l = new RegExp(r, "g");

	numberAsStringToFormat += ""; 

	if(Number.isFinite(+numberAsStringToFormat)){ 
		numberAsStringToFormat = numberAsStringToFormat.replace(".", characterToBeReplacedWith); 
	}

	numberAsStringToFormat = numberAsStringToFormat.replace(l, "").replace(o, ".");
	const s = (numberAsStringToFormat = `${Number.isFinite(+numberAsStringToFormat) ? +numberAsStringToFormat : 0  }`).split(".");
	const response = (
		s[0] = s[0] || "0",
		s[0].length > 3 && (s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, characterToBeReplaced)),
		s[1] = s[1] || "",
		s[1].length < decimalPlaces ? s[1] += new Array(decimalPlaces - s[1].length + 1).join("0") : s[1] = s[1].slice(0, decimalPlaces),
		s[1].length ? s.join(characterToBeReplacedWith) : s[0]
	);

	return response;
};
  

export default formatNumber;
